import { render, staticRenderFns } from "./StudyInfo.vue?vue&type=template&id=38753aa9&scoped=true"
import script from "./StudyInfo.vue?vue&type=script&lang=js"
export * from "./StudyInfo.vue?vue&type=script&lang=js"
import style0 from "./StudyInfo.vue?vue&type=style&index=0&id=38753aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38753aa9",
  null
  
)

export default component.exports